import axiosInstance from '../api/axios';


// Function to get all students
export const getAllInstructors = async () => {
    try {
        const response = await axiosInstance.get('/instructors');
        return response.data;
    } catch (error) {
        console.error('Error fetching instructors:', error);
        throw error;
    }
};


export const getInstructors = async () => {
    try {
        const response = await axiosInstance.get('/getInstructorByRole?role=Examiner&role=Teacher');
        return response.data;
    } catch (error) {
        console.error('Error fetching instructors:', error);
        throw error;
    }
};

export const getTAs = async () => {
    try {
        const response = await axiosInstance.get('/getInstructorByRole?role=TA');
        return response.data;
    } catch (error) {
        console.error('Error fetching instructors:', error);
        throw error;
    }
};

export const getExaminers = async () => {
    try {
        const response = await axiosInstance.get('/getInstructorByRole?role=Examiner');
        return response.data;
    } catch (error) {
        console.error('Error fetching examiners:', error);
        throw error;
    }
};

export const getReviewers = async () => {
    try {
        const response = await axiosInstance.get('/getInstructorByRole?role=Reviewer');
        return response.data;
    } catch (error) {
        console.error('Error fetching examiners:', error);
        throw error;
    }
};

export const getCodeExaminers = async () => {
    try {
        const response = await axiosInstance.get('/getInstructorByRole?role=CodeExaminer');
        return response.data;
    } catch (error) {
        console.error('Error fetching code examiners:', error);
        throw error;
    }
};